import {useState} from 'react';
import {Button} from '@mui/material';
import NotesOutlinedIcon from '@mui/icons-material/NotesOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import {consoleLog} from '../../../core/utilities/Utilities.js';
import NoteDetailPopup from '../Note/NoteDetailPopup.js';
import COMPONENT_MAP from '../Repository/Components.js';
const file='TaskDeactivatePopup.js';
let parent={};
let noteId=null;
const TaskDeactivatePopup=({taskDeactivateCallback,application,taskId})=>{
    const [noteCreated,setNoteCreated]=useState(false);
    const [newNotePopup,setNewNotePopup]=useState(false);
    
    const handleClickEvent=(args)=>{
        consoleLog({file:file,context:'handleClickEvent',arg_name:'args',arg_value:args});
        switch(args?.action){
            case "new_note":
                parent={
                    parent_field_name:'task_id',
                    parent_name:'Task',
                    parent_field_value:taskId
                }
                setNewNotePopup(true);
                break;
            case "close_popup":
                taskDeactivateCallback({refresh:false});
                break;
            default:
                break;
        }
    }

    const componentBody=()=>{
        if(noteCreated){
            return <Button variant="outlined" onClick={()=>{handleClickEvent({action:'new_note'})}} startIcon={<CheckOutlinedIcon color=""/>}>{application.getLocale("NoteCreatedMessage")}</Button>
        }
        else{
            return <Button variant="outlined" onClick={()=>{handleClickEvent({action:'new_note'})}} startIcon={<NotesOutlinedIcon/>}>{application.getLocale("PopupTitleNewNote")}</Button>
        }
    }

    const popupCallBack=(action,args)=>{
        if(action==="refreshParent"){
            setNoteCreated(true);
            noteId=args.id;
        }
        setNewNotePopup(false);
    }

    const renderDetailFormPopup=()=>{
        const Component=COMPONENT_MAP['DetailFormPopup'];
        return Component?(
            <Component
                key={'DetailFormPopup'}
                title={application.getLocale("PopupTaskTitle")}
                application={application}
                handleClickEvent={handleClickEvent}
                isChanged={false}
                componentBody={componentBody()}
                readOnly={true}
                recordRules={null}
            />
        ):null; 
    };

    return(
        <>
            {newNotePopup&&<NoteDetailPopup popupCallBack={popupCallBack} application={application} rowId={noteId} parent={parent} fromPopup={true}></NoteDetailPopup>}
            {renderDetailFormPopup()}
        </>);
}

export default TaskDeactivatePopup;